<ngx-spinner
  [fullScreen]="true" 
  type="ball-clip-rotate-multiple" 
  size="medium"
  bdColor="rgb(242 127 118)"
  >
<p class="loading">Carregando...</p>
</ngx-spinner>
